const alertBus = new EventTarget();

export default alertBus;